import {analyticsLogEvent} from '../api'

const eventName = 'internalSearch'
const eventCategory = 'Internal Search'

type EventInternalSearchAction = 'Ideas' | 'Tips' | 'Suggestion' | (string & {})

interface Parameters {
    action: EventInternalSearchAction
    label: string
}

/**
 * Tracks an internal search event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventNewsletterAction} params.action - Action of the event.
 * @param {string} params.label - Label of the event.
 */
export function analyticsEventInternalSearch({action, label}: Parameters): void {
    const eventDetails = {
        eventCategory: eventCategory,
        eventAction: action,
        eventLabel: label,
    }

    analyticsLogEvent(eventName, eventDetails)
}
